import { render, staticRenderFns } from "./BaseBackButton.vue?vue&type=template&id=16fe9dd0"
import script from "./BaseBackButton.vue?vue&type=script&lang=js"
export * from "./BaseBackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports